import { useState } from "react";
import { Button, Navbar } from "react-bootstrap";
import logoSvg from "../theme/logo.svg";
import { LinkContainer } from "react-router-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import DynamicMenu from "./DynamicMenu";
import ResourceToggle from "./ResourceToggle";
import { loginRequest } from "../utils/authConfig";
import { AccountInfo } from "../store/initialState";
import ShowToRole from "./ShowToRole";

const DuckNav = ({ login, logout, isAuthenticated, user }: { login: Function; logout: Function; isAuthenticated: boolean; user: AccountInfo }) => {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const getAdminButton = () => {
    return (
      <ShowToRole allowedRoles={["volunteer_portal:admin"]}>
        <Button className="ms-2" variant="light" size="sm" onClick={() => navigate("/admin")}>
          Admin <FontAwesomeIcon icon="feather" />
        </Button>
      </ShowToRole>
    );
  };
  const getECAdminButton = () => {
    return (
      <ShowToRole allowedRoles={["volunteer_portal:ecadmin"]}>
        <Button className="ms-2" variant="light" size="sm" onClick={() => navigate("/admin/rds")}>
          Manage RDs <FontAwesomeIcon icon="directions" />
        </Button>
      </ShowToRole>
    );
  };
  const getPrintButton = () => {
    return (
      <ShowToRole allowedRoles={["volunteer_portal:print"]}>
        <Button className="ms-2" variant="light" size="sm" onClick={() => navigate("/print")}>
          Print Mailer <FontAwesomeIcon icon="print" />
        </Button>
      </ShowToRole>
    );
  };
  const getFormsButton = () => (
    <ShowToRole allowedRoles={["volunteer_portal:forms"]}>
      <Button className="ms-2" variant="light" size="sm" onClick={() => navigate("/forms")}>
        Forms <FontAwesomeIcon icon="keyboard" />
      </Button>
    </ShowToRole>
  );
  const handleToggle = () => {
    setExpanded(!expanded);
  };
  return (
    <Navbar variant="dark" expand="lg" sticky="top" className="masthead shadow bg-slate d-print-none" onToggle={handleToggle}>
      {isAuthenticated && <ResourceToggle />}
      <LinkContainer to="/">
        <Navbar.Brand>
          <img src={logoSvg} alt="Ducks Unlimited" height="120" width="120" className="bg-dugreen"  />
        </Navbar.Brand>
      </LinkContainer>
      <Navbar.Toggle as="button" className="btn btn-light " aria-controls="basic-navbar-nav" style={{ lineHeight: "1.25rem" }}>
        {expanded ? <FontAwesomeIcon icon="times" /> : <FontAwesomeIcon icon="bars" />}
      </Navbar.Toggle>
      <Navbar.Collapse className="justify-content-end">
        <DynamicMenu />
        {!isAuthenticated && (
          <Button variant="light" className="bg-hunterorange border-hunterorange" size="sm" onClick={() => login(loginRequest, "loginRedirect")}>
            Login or Sign Up
          </Button>
        )}
        {isAuthenticated && (
          <>
            <Navbar.Text className="text-light me-2">
              Welcome {user?.name}! {getAdminButton()} {getECAdminButton()} {getPrintButton()} {getFormsButton()}
            </Navbar.Text>
            <Button variant="outline-light" className="bg-hunterorange border-hunterorange" size="sm" onClick={() => logout()}>
              Sign Out <FontAwesomeIcon icon="sign-out-alt" />
            </Button>
          </>
        )}
      </Navbar.Collapse>
    </Navbar>
  );
};

export default DuckNav;
